import { ZoomIn, ZoomOut, Maximize2, Square } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ViewerToolbarProps {
  zoom: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onFit: () => void;
  showBoxes: boolean;
  onToggleBoxes: () => void;
}

export default function ViewerToolbar({ zoom, onZoomIn, onZoomOut, onFit, showBoxes, onToggleBoxes }: ViewerToolbarProps) {
  return (
    <div className="flex items-center gap-1 p-1.5 bg-card/95 backdrop-blur border rounded-md shadow-sm">
      <Button variant="ghost" size="icon" className="h-7 w-7" onClick={onZoomIn} title="Zoom in">
        <ZoomIn className="h-3.5 w-3.5" />
      </Button>
      <Button variant="ghost" size="icon" className="h-7 w-7" onClick={onZoomOut} title="Zoom out">
        <ZoomOut className="h-3.5 w-3.5" />
      </Button>
      <Button variant="ghost" size="icon" className="h-7 w-7" onClick={onFit} title="Fit to view">
        <Maximize2 className="h-3.5 w-3.5" />
      </Button>
      <span className="text-xs text-muted-foreground px-1 min-w-[40px] text-center">{Math.round(zoom * 100)}%</span>

      <div className="w-px h-4 bg-border mx-1" />

      <Button
        variant={showBoxes ? 'secondary' : 'ghost'}
        size="icon"
        className="h-7 w-7"
        onClick={onToggleBoxes}
        title="Toggle bounding boxes"
      >
        <Square className="h-3.5 w-3.5" />
      </Button>
    </div>
  );
}
